import { Typography, BlackButton } from "../components";

export const PageNotFoundComponent = () => {

    return (
        <div className="flex flex-col w-screen h-screen">
            <div className="flex-1 flex flex-col justify-center items-center text-center">
                <Typography color="primaryblack" size="header1">404</Typography>
                <Typography color="primaryblack" size="header3" style={{ marginTop: "24px", marginBottom: "36px" }}>
                    چنین صفحه ای وجود ندارد.
                </Typography>
                <BlackButton >رفتن به صفحه اصلی</BlackButton>
            </div>
        </div>
    );
}

export default PageNotFoundComponent;
